<h1 class="title-modal-historic" mat-dialog-title>
  <strong>Historic of this function </strong>
  <mat-icon (click)="onClose()">close</mat-icon>
</h1>
<div class="container">
  <div fxFlexOffset="10px">
    <mat-form-field fxFlex="100%" fxFlex.xs="100%">
      <mat-label>Filter</mat-label>
      <input matInput [formControl]="search" placeholder="Ex. ium" />
    </mat-form-field>
  </div>
  <div class="historique-container" micScrollBar>
    @if (this.dataSource.data.length === 0) {
    <mic-spinner color="accent" [strokeWidth]="5"></mic-spinner>
    } @else {
    <mic-table [config]="tableConfig" [dataSource]="dataSource">
      <ng-container *micCellTemplate="let item; name: 'status'">
        <mat-icon [class]="item.status">{{ utilService.getTableRowStatusIcon(item.status) }}</mat-icon>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'file'">
        <a [href]="fileLink(item.id)" class="file_download"><mic-icon icon="file_download"></mic-icon></a>
      </ng-container>
      <ng-container *micRowDetail="let item">
        <mat-tab-group>
          @for (sheet of item.importFileCsvStatuses; track sheet.id) {
          <mat-tab>
            <ng-template mat-tab-label>
              <div class="toto">
                {{ sheet.fileName }}
                <mat-icon [class]="sheet.status">{{ utilService.getTableRowStatusIcon(sheet.status) }}</mat-icon>
              </div>
            </ng-template>
            <div class="historic-sheet">
              @if (sheet.status === 'OK') {
              <p>The sheet was inserted successfully</p>
              } @if (sheet.status === 'KO') { @for (error of sheet.errorList; track $index) {
              <ul>
                <li>
                  <span class="warning"><mic-icon icon="warning"></mic-icon></span>The error is in the column {{ error.columnNumber }} in
                  the line {{ error.line }}. The value does not respect the regular expression that must be used.
                </li>
              </ul>
              } } @if (sheet.status === 'HELP') {
              <p>The sheet {{ sheet.fileName }} was not Found</p>
              }
            </div>
          </mat-tab>
          }
        </mat-tab-group>
      </ng-container>
    </mic-table>
    }
  </div>
</div>
